// Patches studentsWithNoGroup into each set after the background fetch completes.
// This data is only needed for Edit/Create Group dialogs, not for page render.
const fetchGroupSetsNoGroupStudentsReducer = (state, action) => {
  if (action.status !== 'success') return state;

  const { noGroupStudentsPerSet } = action.payload;

  const updatedSets = { ...state.sets };
  noGroupStudentsPerSet.forEach(({ setId, data }) => {
    if (updatedSets[setId]) {
      updatedSets[setId] = { ...updatedSets[setId], ...data };
    }
  });

  return { ...state, sets: updatedSets };
};

export default fetchGroupSetsNoGroupStudentsReducer;
